import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServicesSearch } from '../../../../search/services/search.service';
import { CriteriUtente } from '../../../models/criteri-utente';
import { CriterioCustom } from '../../../models/criterio-custom';
import { SearchRequest } from '../../../models/dto/search-request';
import { SearchResponse } from '../../../models/dto/search-response';
import { PraticaLight } from '../../../models/pratica/pratica-light';

@Component({
    selector: '[searchPraticheInput]',
  templateUrl: 'search-pratiche.component.html',
  styleUrls: ['search-pratiche.component.css'],
  host: { '[class.row]': '\'true\'' }
})

export class SearchPraticheComponent implements OnInit {
  @Input() idPraticaBase: string;
  @Input() placeholder: string;
  @Input() correlateResearch: boolean;
  @Input() soloPratiche: boolean = true;
  @Input() ordineAscendente: boolean;
  searchText: string;
  randomId: string = null;
  @Output() onReturn: EventEmitter<SearchResponse> = new EventEmitter<SearchResponse>();
  @Output() onReload: EventEmitter<SearchResponse> = new EventEmitter<SearchResponse>();
  private lastCharacterInsertedTimeInMillis: number = -1;
  private searchRequest: SearchRequest;
  constructor(private services: ServicesSearch) { }

  ngOnInit(): void {
    this.randomId = this.getRandomId();
  }

  onChange() {
    let newValue = this.searchText;
    let now = new Date().getTime();
    this.lastCharacterInsertedTimeInMillis = now;
    let model: SearchPraticheComponent = this;
    setTimeout(function() {
      if (now == model.lastCharacterInsertedTimeInMillis) {
        model.manageValue(newValue.trim());
      }
    }, 500);
  }

  manageValue(newValue: string) {
    if (newValue.length < 3) {
      this.onReturn.emit(null);
    } else {
      this.searchRequest = new SearchRequest();
      this.searchRequest.searchCriteria.searchText = newValue;
      this.searchRequest.includePratiche = true;
      this.searchRequest.includeDocuments = false;
      if(this.soloPratiche) this.searchRequest.soloPratiche = true;
      this.searchRequest.fromResult = 0;
      this.searchRequest.searchCriteria.criteriUtente = new CriteriUtente();
      if (this.ordineAscendente) {
        this.searchRequest.asc = this.ordineAscendente;
      } else {
        this.searchRequest.asc = false;
      }
      this.searchRequest.nomeCampoOrdinamento = 'dataApertura';
      if (this.correlateResearch) {
        let criterioCorrelate: CriterioCustom = new CriterioCustom();
        criterioCorrelate.uid = 'correlate';
        criterioCorrelate.value = this.idPraticaBase;
        this.searchRequest.searchCriteria.criteriUtente.criteriCustom['correlate'] = criterioCorrelate;
      }
      this.services.search(this.searchRequest).subscribe(response => this.emitList(response));
    }
  }



  emitList(response: SearchResponse) {
    let pratiche: PraticaLight[] = <PraticaLight[]>response.pratiche;
    this.removePraticaFromArray(this.idPraticaBase, pratiche);
    this.onReturn.emit(response);
  }

  emitListOnreload(response: SearchResponse) {
    let pratiche: PraticaLight[] = <PraticaLight[]>response.pratiche;
    this.removePraticaFromArray(this.idPraticaBase, pratiche);
    this.onReload.emit(response);
  }

  removePraticaFromArray(idPraticaBase: string, pratiche: PraticaLight[]) {
    for (let i = 0; i < pratiche.length; i++) {
       let obj: PraticaLight = pratiche[i];
      if (obj.id === idPraticaBase) {
        pratiche.splice(i, 1);
      }
    }
  }

  reloadCallback(resutlParziale) {
    this.searchRequest.fromResult = resutlParziale;
    this.services.search(this.searchRequest).subscribe(response => this.emitListOnreload(response));
  }

  onResetSearchText(){
    this.searchText = undefined;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }
}
